import * as Yup from 'yup';

export const ProfileAddFilesFormValidationSchema = Yup.object().shape({
  files: Yup.array().of(
    Yup.object()
      .test(
        'hasDescription',
        'You should fill description.',
        value => value.description && value.description.length > 0
      )
      .test(
        'maxDescription',
        'Please input a Description less than 256 characters.',
        value => value.description.length <= 256
      )
      .test(
        'maxSize',
        'Size of file should be less than 2 MB.',
        value => value.file.size <= 2 * 1024 * 1024
      )
  ),
});
